import React, { useEffect, useRef, useState } from "react";
import { translateText } from "../../../../../../Helper_functions";

const SearchSelect = (props) => {
  const SearchTimeoutRef = useRef(null);
  const [IsOpen, setIsOpen] = useState(false);
  const [PlaceholderIsShown, setPlaceholderIsShown] = useState(true);
  const [SelectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    setSelectedOptions(props.PreSelectedOptions);
  }, [props.PreSelectedOptions]);

  const handleSearch = () => {
    let Keyword = document.getElementById("search-skills").value;
    setSelectedOptions([]);
    setSelectedOptions(
      Array.from(new Set(JSON.parse(localStorage.getItem("newArray"))))
    );
    props.ToggleSearch(Keyword);
  };

  const handleValueChange = (e) => {
    if (e.target.value.length > 0) {
      setPlaceholderIsShown(false);
      if (SearchTimeoutRef.current) {
        clearTimeout(SearchTimeoutRef.current);
      }
      SearchTimeoutRef.current = setTimeout(() => {
        handleSearch();
      }, 1500);
    } else {
      setPlaceholderIsShown(true);
      props.RemoveSelectedState();
      props.UpdateList(SelectedOptions);
      setTimeout(() => {
        props.ToggleSearch("");
      }, 200);
    }
  };

  const selectOption = (Item) => {
    document
      .getElementById("search-select-wrapper")
      .classList.remove("error-shown");

    let Selected = []; // selected options that are already checked

    if (
      document
        .getElementById(Item.id + "-option")
        .classList.contains("selected")
    ) {
      document.getElementById(Item.id + "-option").classList.remove("selected");
    } else if (
      Array.from(new Set(JSON.parse(localStorage.getItem("newArray")))).length <
      5
    ) {
      document.getElementById(Item.id + "-option").classList.add("selected");
    }

    SelectedOptions.concat(props.Options).map((Item) => {
      if (
        document
          .getElementById(Item.id + "-option")
          .classList.contains("selected")
      ) {
        Selected.push(Item);
      }
    });
    let NewArray = JSON.stringify(Array.from(new Set(Selected)));
    localStorage.setItem("newArray", NewArray);
  };

  const updateSelectedItems = (WillBeAdded, SelectedOption) => {
    let AllOptions = [...props.Options].concat([...SelectedOptions]);
    let SelectedOpts = []; // selected items based on className "selected"

    // This is true when closing the dropdown or selecting a new option
    if (WillBeAdded) {
      AllOptions.map((Opt) => {
        if (
          document.getElementById(Opt.id + "-option") !== null &&
          document
            .getElementById(Opt.id + "-option")
            .classList.contains("selected") &&
          SelectedOpts.indexOf(Opt) === -1
        ) {
          SelectedOpts.push(Opt);
        }
      });
      if (SelectedOption) {
        SelectedOpts = [...SelectedOpts, SelectedOption];
      }
      setSelectedOptions(Array.from(new Set(SelectedOpts)));
    }
  };

  const close = () => {
    updateSelectedItems(true);
    props.UpdateList(
      Array.from(new Set(JSON.parse(localStorage.getItem("newArray"))))
    );
    props.RemoveSelectedState();
    setTimeout(() => {
      setIsOpen(false);
    }, 150);
  };

  const handleClear = () => {
    setSelectedOptions([]);
    localStorage.removeItem("newArray");
    props.ClearInput();
    props.UpdateList([]);
  };

  const displayOption = (Item) => {
    if (Item.title.length > 0 && SelectedOptions.indexOf(Item) === -1) {
      return (
        <span
          className="option-item"
          id={Item.id + "-option"}
          onClick={() => selectOption(Item)}
        >
          <i className="feather-check"></i>
          <p>{Item.title}</p>
        </span>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="search-select-wrapper" id="search-select-wrapper">
      {IsOpen ? <div className="outline" onClick={() => close()}></div> : null}
      <div className="trigger" onClick={() => setIsOpen(!IsOpen)}>
        <span className="selected-trigger">
          <p className="selected-count" id="search-select-selected-count">
            {SelectedOptions.length + " Selected"}
          </p>
        </span>
        <i className="feather-chevron-down"></i>
      </div>
      {SelectedOptions.length > 0 ? (
        <i
          onClick={() => handleClear()}
          id="search-select-clear"
          className="feather-x-circle"
        ></i>
      ) : null}

      <div className={IsOpen ? "search-dropdown is-shown" : "search-dropdown"}>
        <i className="feather-search"></i>
        {PlaceholderIsShown ? (
          <p className="search-placeholder">{props.SearchLabel}</p>
        ) : null}
        <input
          onChange={(e) => handleValueChange(e)}
          className="search-input"
          id="search-skills"
          autoComplete="off"
        />
        {IsOpen ? (
          <React.Fragment>
            <section className="options-wrapper">
              <React.Fragment>
                {Array.from(new Set(SelectedOptions)).map((Item, i) => (
                  <React.Fragment key={i}>
                    {Item.title.length > 0 ? (
                      <span
                        className="option-item selected"
                        id={Item.id + "-option"}
                        onClick={() => selectOption(Item)}
                      >
                        <i className="feather-check"></i>
                        <p>{Item.title}</p>
                      </span>
                    ) : null}
                  </React.Fragment>
                ))}
              </React.Fragment>
              {props.Options.length === 0 ? (
                <section className="options-wrapper">
                  <p className="no-res-text">
                    {translateText("no_results_found", props.LangData)}
                  </p>
                </section>
              ) : (
                <React.Fragment>
                  {props.Options.map((Item, i) => (
                    <React.Fragment key={i}>
                      <>{displayOption(Item)}</>
                    </React.Fragment>
                  ))}
                </React.Fragment>
              )}
            </section>
          </React.Fragment>
        ) : null}
      </div>
      {props.ValidationText ? (
        <p className="search-select-validation-text">{props.ValidationText}</p>
      ) : null}
    </div>
  );
};
export default SearchSelect;
